import { registerPlugin } from '@capacitor/core';
import { SystemUiModels } from './system-ui.model';

export const SystemUi =
  registerPlugin<SystemUiModels.SystemUiPlugin>('SystemUi');
